import {describeDomElement} from './describe-dom-element';
import {destroyModulesFromEl} from './destroy-modules-from-el';

function handleError(el, err) {
    Hop.logError(
        'Could not destroy module for element '
        + describeDomElement(el)
        + ': '
        + JSON.stringify(el)
        + ' (see error detail in next log)',
    );

    Hop.logError(err);
}

export function detachModulesFromEl(el) {
    try {
        destroyModulesFromEl(el);
    } catch (err) {
        handleError(el, err);
    }
}
